import { forEach, replace, without, upperFirst, toString } from 'lodash';

export function normalizeFormData(clientData) {
    const possiblePhoneFields = ['phone', 'cellphone', 'emergency_contact_phone_number'];

    forEach(possiblePhoneFields, (phoneField) => {
        if(clientData[phoneField]) {
            clientData[phoneField] = normalizePhone(clientData[phoneField]);
        }
    });

    clientData.nam = normalizeWhiteSpace(clientData.nam);
    clientData.postal_code = normalizeWhiteSpace(clientData.postal_code);
    clientData.covid_screening_country = normalizeCovidScreeningCountry(clientData.covid_screening_country);
    clientData.region = normalizeUpperFirst(clientData.region);
    clientData.covid_screening_healthcare_institution_type = normalizeUpperFirst(clientData.covid_screening_healthcare_institution_type);
    clientData.covid_screening_student_level = normalizeUpperFirst(clientData.covid_screening_student_level);
    clientData.covid_screening_student_school_region = normalizeUpperFirst(clientData.covid_screening_student_school_region);
    clientData.gender = normalizeUpperFirst(clientData.gender);

    return clientData;
}

export function normalizeCovidScreeningCountry(value) {
    if(!value) {
        return value;
    }
    return toString(without(value, 'null', ''));
}

export function normalizeUpperFirst(value) {
    if(!value) {
        return value;
    }
    return upperFirst(value);
}

/**
 * @description Extracts only the digits from a formatted phone number
 */
export function normalizePhone(numberStr) {
    return replace(numberStr, /\D+/g, '');
}

export function normalizeWhiteSpace(value) {
    return replace(value, /\s/g, '');
}
